import { render, staticRenderFns } from "./TablaRegistroWithoutPayment.vue?vue&type=template&id=127aeafa&scoped=true&"
import script from "./TablaRegistroWithoutPayment.vue?vue&type=script&lang=js&"
export * from "./TablaRegistroWithoutPayment.vue?vue&type=script&lang=js&"
import style0 from "./TablaRegistroWithoutPayment.vue?vue&type=style&index=0&id=127aeafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127aeafa",
  null
  
)

export default component.exports